
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.4 18.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.1 9.2l-2.4-2.4c-.1-.1-.3-.2-.5-.2h-2.4V3.3c0-.3-.2-.5-.4-.5H10c.2.5.3 1 .3 1.5h4.2v8.6H4.2v-2.6c-.5 0-1-.1-1.5-.3v3.9c0 .3.2.5.4.5H4.5c-.3.7-.4 1.5-.1 2.2.3.8 1 1.4 1.9 1.6 1.5.3 2.9-.6 3.2-2.1 0-.2.1-.3.1-.5 0-.4-.1-.8-.3-1.2h5.3c-.3.7-.4 1.5-.1 2.2.3.8 1 1.4 1.9 1.6 1.5.3 2.9-.6 3.2-2.1 0-.2.1-.3.1-.5 0-.4-.1-.8-.3-1.2h1.3c.3 0 .5-.2.5-.4V9.7c.1-.2.1-.4-.1-.5zm-13 6.4c0 .6-.5 1.2-1.1 1.2h-.1c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2c.7-.1 1.2.4 1.2 1.2 0-.1 0-.1 0 0zm10.1 0c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2.5-1.2 1.2-1.2c.7-.1 1.2.4 1.2 1.2 0-.1 0-.1 0 0zm1.7-2.7h-4V8.1h2c.1 0 .1 0 .1.1l1.8 1.8.1.1v2.8z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M4.5.1C2 .1 0 2.1 0 4.6.1 7 2.1 9 4.5 9 7 9 9 7 9 4.6 9 2.1 7 .1 4.5.1zm2.7 3.3L4.4 6.8c-.1.2-.3.3-.6.3h-.2l-.3-.2-1.5-1.4c-.2-.1-.3-.4-.3-.6 0-.2.1-.4.2-.6.4-.3.9-.3 1.2 0l.8.7 2.2-2.6c.1-.2.4-.3.6-.3.2 0 .4.1.6.2.3.3.3.8.1 1.1z"}})])
          )
        }
      }
    